import React, { useEffect, useState } from 'react'
import { FormatMoney } from '../../../Helpers/FormatNumber';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import FiltroMultiple from '../../Postventa/Dashboard/Modales/FiltroMultiple';

const MESES = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

const CAMPOS = ["sucursal", "cliente", "mes", "vendedor"];

export const TablaPolizaMantenimiento = ({ data, onAgregar, onEliminar, permisoEliminar }) => {

    const estadoInicial = () => CAMPOS.reduce((acc, k) => ({ ...acc, [k]: [] }), {});

    const [options, setOptions] = useState(estadoInicial);
    const [filtros, setFiltros] = useState(estadoInicial);
    const [filtrosTemp, setFiltrosTemp] = useState(estadoInicial);
    const [prioridadFiltros, setPrioridadFiltros] = useState([]);
    const [datosFiltrados, setDatosFiltrados] = useState([]);
    const [mostrarFiltro, setMostrarFiltro] = useState(
        CAMPOS.reduce((acc, k) => ({ ...acc, [k]: false }), {})
    );

    const getMesLabel = (item) => MESES[item.mes - 1] ?? "";

    const aplicarFiltros = (base, filt, filtrosPermitidos) => {
        let resultado = [...base];
        filtrosPermitidos.forEach(campo => {
            if (campo === "mes") {
                if (filt.mes.length > 0) {
                    resultado = resultado.filter(i => filt.mes.includes(getMesLabel(i)));
                }
            } else {
                if (filt[campo]?.length > 0) {
                    resultado = resultado.filter(i => filt[campo].includes(i[campo]));
                }
            }
        });
        return resultado;
    };

    const actualizarPrioridad = (filtro) => {
        setPrioridadFiltros(prev => {
            const index = prev.indexOf(filtro);
            const nuevasPrioridades = index === -1 ? [...prev, filtro] : prev.slice(0, index + 1);

            setFiltrosTemp(prevTemp => {
                const limpio = { ...prevTemp };
                CAMPOS.forEach(key => { if (!nuevasPrioridades.includes(key)) limpio[key] = []; });
                return limpio;
            });
            setFiltros(prevFiltros => {
                const limpio = { ...prevFiltros };
                CAMPOS.forEach(key => { if (!nuevasPrioridades.includes(key)) limpio[key] = []; });
                return limpio;
            });

            return nuevasPrioridades;
        });
    };

    useEffect(() => {
        if (!Array.isArray(data)) return;

        let resultado = [...data];
        prioridadFiltros.forEach(campo => {
            if (campo === "mes") {
                if (filtros.mes.length > 0) {
                    resultado = resultado.filter(i => filtros.mes.includes(getMesLabel(i)));
                }
            } else {
                if (filtros[campo]?.length > 0) {
                    resultado = resultado.filter(i => filtros[campo].includes(i[campo]));
                }
            }
        });

        setDatosFiltrados(resultado);
    }, [data, filtros, prioridadFiltros]);

    useEffect(() => {
        if (!Array.isArray(data)) return;

        const getBaseData = (campo) => {
            const index = prioridadFiltros.indexOf(campo);
            if (index === -1) return aplicarFiltros(data, filtros, prioridadFiltros);
            if (index === 0) return data;
            return aplicarFiltros(data, filtros, prioridadFiltros.slice(0, index));
        };

        const newOptions = {};
        CAMPOS.forEach(campo => {
            if (campo === "mes") {
                newOptions.mes = [...new Set(getBaseData("mes").map(getMesLabel))]
                    .map(v => ({ value: v, label: v }));
            } else {
                newOptions[campo] = [...new Set(getBaseData(campo).map(i => i[campo] ?? ""))]
                    .map(v => ({ value: v, label: v }));
            }
        });

        setOptions(newOptions);
    }, [data, filtros, prioridadFiltros]);

    const filtroProps = (campo) => ({
        field: campo,
        options: options[campo] || [],
        filtros,
        setFiltros,
        filtrosTemp,
        setFiltrosTemp,
        mostrarFiltro,
        setMostrarFiltro,
        actualizarPrioridad,
    });

    return (
        <div className='paquete-servicio-poliza-mantenimiento-tabla scroll-4'>
            <table cellPadding={0} cellSpacing={0}>
                <thead>
                    <tr>
                        <th>
                            <FiltroMultiple label="Sucursal" {...filtroProps("sucursal")} />
                        </th>
                        <th>
                            <FiltroMultiple label="Cliente" {...filtroProps("cliente")} />
                        </th>
                        <th>
                            <div>Serie</div>
                        </th>
                        <th>
                            <div>Periodo</div>
                        </th>
                        <th>
                            <div># Factura</div>
                        </th>
                        <th>
                            <div>Interna/Externa</div>
                        </th>
                        <th>
                            <div>Mano Obra</div>
                        </th>
                        <th>
                            <div>Refacciones</div>
                        </th>
                        <th>
                            <div>KM</div>
                        </th>
                        <th>
                            <div>Monto Facturado</div>
                        </th>
                        <th>
                            <div>Orden Trabajo</div>
                        </th>
                        <th>
                            <FiltroMultiple label="Mes" {...filtroProps("mes")} />
                        </th>
                        <th>
                            <FiltroMultiple label="Vendedor" {...filtroProps("vendedor")} />
                        </th>
                        <th>
                            <div>Editar</div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {datosFiltrados.map((item, index) => {
                        // Calcula la suma de la fila
                        // const total = [
                        //     item.enero,
                        //     item.febrero,
                        //     item.marzo,
                        //     item.abril,
                        //     item.mayo,
                        //     item.junio,
                        //     item.julio,
                        //     item.agosto,
                        //     item.septiembre,
                        //     item.octubre,
                        //     item.noviembre,
                        //     item.diciembre
                        // ].reduce((acc, val) => acc + (parseFloat(val) || 0), 0); // Asegura que se sumen solo números

                        return (
                            <tr key={index}>
                                <td className='columna-centrada'>{item.sucursal}</td>
                                <td>{item.cliente}</td>
                                <td className='columna-centrada'>{item.serie}</td>
                                <td>{item.periodo}</td>
                                <td className='columna-centrada'>{(item.num_factura)}</td>
                                <td>{item.tipo === "I" ? "Interna" : "Externa"}</td>
                                <td className='columna-centrada'>{FormatMoney(item.mano_obra)}</td>
                                <td>{(FormatMoney(item.refacciones))}</td>
                                <td className='columna-centrada'>{FormatMoney(item.km)}</td>
                                <td className='columna-centrada'>{FormatMoney(item.facturacion)}</td>
                                <td>{item.orden_trabajo}</td>
                                <td>{MESES[item.mes - 1]}</td>
                                <td>{item.vendedor}</td>
                                <td className='columna-centrada'>
                                    <div className='container-botones'>
                                        <div
                                            className='boton-editar'
                                            onClick={() => onAgregar(item.idpoliza)}
                                        >
                                            <EditIcon />
                                        </div>
                                        {permisoEliminar === true && (
                                            <div
                                                className='boton-eliminar'
                                                onClick={() => onEliminar(item.idpoliza, "mantenimiento")}
                                            >
                                                <DeleteIcon />
                                            </div>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
        </tbody>
      </table>
    </div>
  );
};
